import { Router } from "@angular/router";
import { HttpService } from "./http-service";
import { HttpClient } from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { InitProvider } from "./init-provider";
import * as CryptoJS from "crypto-js";
import { Configuracoes } from "../entities/configuracoes";
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from "src/enviroment";
@Injectable({
  providedIn: "root",
})
export class SecurityService extends HttpService {
  public form;
  public callbackLoginOk;
  public callbackError;

  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object,
    public initProvider: InitProvider
  ) {
    super(http, router, toastService, platformId);
  }

  decryptData(encryptedData, secretKey) {
    try {
      const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
      const iv = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(0, 4),
        16
      );
      const encryptedMessage = CryptoJS.lib.WordArray.create(
        encryptedDataBytes.words.slice(4),
        encryptedDataBytes.sigBytes - 16
      );
      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedMessage },
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("Decryption failed:", e);
      return "";
    }
  }

  isPainel(): boolean {
    return localStorage.getItem("tipoUsuario") === "PAINEL";
  }
  decryptAndShow(encrypted) {
    const secretKey = environment.version;
    const encryptedData = encrypted;

    if (encryptedData === "" || secretKey === "") {
      console.error("Encrypted data or secret key is empty.");
      return;
    }

    const decryptedData = this.decryptData(encryptedData, secretKey);
    return decryptedData;
  }
  generateHash(obj: string, salt: string): string {
    const jsonString = JSON.stringify(obj);
    const key = CryptoJS.enc.Utf8.parse(environment.version);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedStr = CryptoJS.enc.Base64.stringify(
      iv.concat(encrypted.ciphertext)
    );
    return encryptedStr;
  }

  loginCipher(formLogin, callbackSuccess, callbackError) {
    this.form = formLogin;
    this.callbackLoginOk = callbackSuccess;
    this.callbackError = callbackError;
    let cripto = this.generateHash(
      JSON.stringify(formLogin),
      environment.version
    );
    this.post(
      "auth",
      { dados: cripto },
      this.loginSuccessCipher.bind(this),
      this.loginError.bind(this)
    );
    // }
  }

  login(formLogin, callbackSuccess, callbackError) {
    if (Configuracoes.cypher) {
      this.form = formLogin;
      this.callbackLoginOk = callbackSuccess;
      this.callbackError = callbackError;
      let cripto = this.generateHash(
        JSON.stringify(formLogin),
        environment.version
      );
      this.postLogin(
        "auth",
        { dados: cripto },
        this.loginSuccessCipher.bind(this),
        this.loginError.bind(this)
      );
    } else {
      this.form = formLogin;
      this.callbackLoginOk = callbackSuccess;
      this.callbackError = callbackError;
      this.postLogin(
        "auth",
        formLogin,
        this.loginSuccess.bind(this),
        this.loginError.bind(this)
      );
    }
  }

  recuperaSenha(form, callbackSuccess, callbackError) {
    this.post("auth/recuperaSenha", form, callbackSuccess, callbackError);
  }

  loginSuccessCipher(resp) {
    this.initProvider.usuario = JSON.parse(this.decryptAndShow(resp.dados));
    localStorage.setItem(
      "token",
      JSON.parse(this.decryptAndShow(resp.dados)).token
    );
    localStorage.setItem(
      "tipoUsuario",
      JSON.parse(this.decryptAndShow(resp.dados)).tipo
    );
    this.toastService.info($localize`Usuário logado com sucesso!`);
    this.router.navigate([""]);
    this.callbackLoginOk(JSON.parse(this.decryptAndShow(resp.dados)));
    this.initProvider.load();
  }

async loginSuccess(resp) {
  try {
    this.initProvider.usuario = resp;
    localStorage.setItem("token", resp.token);
    localStorage.setItem("tipoUsuario", resp.tipo);
    this.toastService.info($localize`Usuário logado com sucesso!`);
    this.callbackLoginOk(resp);
    
    // Aguarda o load completar antes de navegar
    await this.initProvider.load();
    
    // Navega apenas após o load terminar
    this.router.navigate([""]);
    
    //console.log('login usuario', resp);
  } catch (error) {
    console.error('Erro durante o login:', error);
    this.toastService.error($localize`Erro ao carregar dados do usuário`);
  }
}

  loginError(error) {
    this.callbackError(error);
  }

  isType(type: string) {
    if (isPlatformBrowser(this.plataformId)) {
    return (
      localStorage.getItem("tipoUsuario") != null &&
      localStorage.getItem("tipoUsuario") == type
    );
  }
  }

  hasToken() {
    if (isPlatformBrowser(this.plataformId)) {
      return window.localStorage.getItem("token") != null;
    }
  }

  logout() {
    if (isPlatformBrowser(this.plataformId)) {
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("tipoUsuario");
        window.localStorage.removeItem("pedido");
      });
    }
    this.initProvider.usuario = null;
  }
}
